/// <reference path="../app.definition.ts" />

import angular from "angular";
import { saveAs } from 'file-saver';
import jsSHA from 'jssha';
import { MEMBER_STATUS } from "@common/model/subject";
import { Util } from "@common/util";
import { IAppRootScopeService } from "@app/app.definition";
import { JavaApiAdapterService } from "@common/apiadapter/javaapi.service";
import { CacheService } from "@common/service/cache.service";
import { PopUpService } from "@common/popup/popup.service";

    // define & export class
    export class CommonService {
        static $inject = ["$rootScope", "ApiAdapterService",
            "CacheService", "$state", "baseUrl", "$http", "PopUpService", "$uibModal", "$q", "$filter", "authConfig", "storageConfig", "ecareEnv"];
        hashPassword;
        getExtension;
        addRole;
        downloadViaBrowser;
        showInvitationMsg = true;
        static stack = [];
        static runningTask = 0;
        isMobile;
        setIsMobile;
        showTooltipPopup;
        fetchSasToken;
        downloadDocument: (filename: any, type: any, content: any, decodingRequired?: boolean, combineFlag?: any) => void;
        uuidv4: () => string;
        delegate: (scope: any, method: any, success_callback: any) => () => any;
        addToStack: (func: any, priority?: any) => void;
        resetStack: () => void;
        base64ToBlob: (type: any, content: any, decodingRequired?: boolean) => any;
        sendReminder: (subject: any, user: any) => any;
        sendInvite: (subject: any, user: any, message?: any, inviteWithCoCaptain?: boolean) => any;
        OpenSendInvitationModal: (subject: any, teamMember: any) => any;
        getSignUrlFrSignature: (bucket: any, sgnUrl: any) => any;

        constructor(
        private $rootScope: IAppRootScopeService,
        private ApiAdapterService: JavaApiAdapterService,
        private CacheService: CacheService,
        private $state: ng.ui.IStateService,
        private baseUrl: string,
        private $http: ng.IHttpService,
        private PopUpService: PopUpService,
        private $uibModal: ng.ui.bootstrap.IModalService,
        private $q: ng.IQService,
        private $filter: ng.IFilterService,
        private authConfig: any,
        private storageConfig: any,
        private ecareEnv: string) {


            this.uuidv4 = () => {
                return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                    const r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
                    return v.toString(16);
                });
            }

            // this is a delegate fucntion being used in CommonService & CareTeam

            this.delegate = (scope, method, success_callback, ...args: any[]) => {
                if (args.length > 0) {
                    return function () {
                        CommonService.runningTask++;
                        return method.apply(scope, args).then((s) => {
                            CommonService.runningTask--;
                            success_callback(s);
                        }, (e) => { CommonService.runningTask-- });
                    }
                } else {
                    return function () { return method.call(scope); }
                }
            }

            this.addToStack = (func, priority?) => {
                if (!!priority) {
                    func();
                } else {

                    CommonService.stack.push(func);
                    window.setInterval(function () {
                        if (CommonService.stack.length > 0 && CommonService.runningTask < 5) {
                            console.log('adding task')
                            const func0 = CommonService.stack.shift();
                            func0();
                        }
                    }, 100);
                }
            }

            this.resetStack = () => {
                CommonService.stack = [];
            }

            this.base64ToBlob = (type, content, decodingRequired = false) => {
                const deferred = this.$q.defer();
                let bParam;

                if (decodingRequired) {
                    // Convert the Base64 string back to text.
                    const byteString = type == "text/plain" ? content : atob(content);

                    // Convert that text into a byte array.
                    const ab = new ArrayBuffer(byteString.length);
                    bParam = new Uint8Array(ab);
                    for (let i = 0; i < byteString.length; i++) {
                        bParam[i] = byteString.charCodeAt(i);
                    }
                } else {
                    bParam = content;
                }
                let blob;
                if (!!type) {
                    blob = new Blob([bParam], { type: type });
                } else {
                    blob = new Blob([bParam]);
                }
                deferred.resolve(blob);
                return deferred.promise;
            }

            this.downloadDocument = (filename, type, content, decodingRequired = false, combineFlag = null) => {
                {
                    this.base64ToBlob(type, content, decodingRequired).then((blob) => {
                        if (combineFlag == "print") {

                        } else if (combineFlag == null || combineFlag == "download") {
                            try {
                                // Tell the browser to save as report.pdf.
                                // FileSaver.saveAs(blob, filename);
                                saveAs(blob, filename);
                            } catch (e) {
                                (window.navigator as any).msSaveBlob(blob, filename);
                            }
                        }
                    });
                }
            }

            this.fetchSasToken = () => {
                const deferred = this.$q.defer();
                const sassObject = this.CacheService.getSASSToken();
                if (!!sassObject && !!sassObject.expiryTime && sassObject.expiryTime > new Date().toISOString()) {
                    deferred.resolve(sassObject); 
                } else {
                    this.ApiAdapterService.getSASSToken().then((token) => {
                        this.CacheService.setSASSToken(token);
                        deferred.resolve(token); 
                    });
                }
                
                return deferred.promise;
            }
            this.downloadViaBrowser = (url, fileName, src) => {
                let frame = document.getElementById('ifrm-download') as HTMLIFrameElement;
                this.fetchSasToken().then(sassData => {
                    frame.src = src + `/download-document.html?${sassData.sasToken}`;
                    setTimeout(() => {
                        frame.contentWindow.postMessage({ url, fileName }, src);
                    }, 1000);
                })                
            }

            // send invitation reminder
            this.sendReminder = (subject, user) => {
                const _subjectId = subject.subjectId;
                const deferred = this.$q.defer();
                const url = this.baseUrl + '#/ecare-vault/login?i=${TOKEN}';
                let isFormerMem = false;

                if (!user || !user.providerIdentity) {

                    this.PopUpService.openInformationModal('User does not contain email address');
                    deferred.reject('User does not contain email address');
                    return;
                }

                if (user.providerStatus == (MEMBER_STATUS.INVITED | MEMBER_STATUS.FORMER)) {
                    isFormerMem = true;
                }
                this.ApiAdapterService.sendInviteToProvider(_subjectId, user.providerIdentity, url, this.CacheService.getPassword(), null, 'teammember', null, null, null, isFormerMem).then(
                    (su) => {
                        this.$rootScope.mainShowLoader = false;
                        deferred.resolve(su);
                    }, e => {
                        deferred.reject(e);
                        this.$rootScope.mainShowLoader = false;
                        this.PopUpService.openInformationModal(e);
                    }
                );

                return deferred.promise;
            }

            this.sendInvite = (subject, user, message?, inviteWithCoCaptain?: boolean) => {
                const _subjectId = subject.subjectId;
                const deferred = this.$q.defer();
                const url = this.baseUrl + '#/ecare-vault/login?i=${TOKEN}';
                let personalMsg = "";
                if (!!message) {
                    personalMsg = message;
                }

                if (!user || !user.providerIdentity) {

                    this.PopUpService.openInformationModal('User does not contain email address');
                    deferred.reject('User does not contain email address');
                    return;
                }

                let isFormerMem = user.isFormerTeamMember;
                if (!isFormerMem && user.providerStatus == (MEMBER_STATUS.INVITED | MEMBER_STATUS.FORMER)) {
                    isFormerMem = true;
                }
                this.ApiAdapterService.sendInviteToProvider(_subjectId, user.providerIdentity, url, this.CacheService.getPassword(), null, 'teammember', user.profileId, personalMsg, inviteWithCoCaptain, isFormerMem).then(
                    (su) => {
                        this.$rootScope.mainShowLoader = false;

                        const secretCode = 'Please share this secret code [case-sensitive] with this user:' + su.code;
                        // TODO : Generaliize all popup messages in one file
                        this.showInvitationMsg && toastr.success(Util.INVITATION_SENT_SUCCESSFULLY, "");
                        deferred.resolve(su);
                    }, e => {
                        deferred.reject(e);
                        this.$rootScope.mainShowLoader = false;
                        this.PopUpService.openInformationModal(e);
                    }
                );

                return deferred.promise;
            }

            //process suggestion from team action
            this.OpenSendInvitationModal = function (subject, teamMember) {
                const deferred = this.$q.defer();

                this.$uibModal.open({
                    templateUrl: 'app/common/popup/inviteTeamMember/inviteTeamMember.html',
                    controller: 'InviteTeamMemberController as inviteTeamMemberVm',
                    resolve: {
                        subject: subject,
                        teamMember: teamMember
                    }
                }).result.then((s) => {
                    deferred.resolve(s);
                });

                return deferred.promise;
            };

            this.hashPassword = (pass) => {
                const shaObj = new jsSHA('SHA-256', 'TEXT');
                shaObj.update(pass);
                const hash = shaObj.getHash('HEX');
                return hash;
            }

            // Here objSubject is the SUBJECT object which is currently in the model of the context from where it is being called
            // currentTeamRoles is the list which is in context of list being used
            // objCurrent is the object in which the teamRoles exist in
            this.addRole = (objSubject, currentTeamRoles, objCurrent) => {
                const deferred = this.$q.defer();

                if (!!objCurrent && objCurrent.teamRoleId != -1) {
                    deferred.resolve();
                    return deferred.promise;
                }
                this.PopUpService.openTeamRolePopUp({ "teamRoles": currentTeamRoles, "subject": objSubject }).then((s) => {
                    if (!!s) {
                        console.log(s);
                        angular.copy(s.teamRoles, currentTeamRoles);// = s.teamRoles;

                        //select the teamRole Added
                        // search for newly added

                        for (let i = 0; !!s.teamRoles && i < s.teamRoles.length; i++) {
                            if (s.newAdded == s.teamRoles[i].roleName) {
                                s.newAddedId = s.teamRoles[i].id;
                            }
                        }
                        if (!!s.newAddedId) {
                            objCurrent.teamRoleId = s.newAddedId;
                        } else {
                            objCurrent.teamRoleId = null;
                        }

                    } else {
                        objCurrent.teamRoleId = null;
                    }
                    deferred.resolve();
                }, (e) => {
                    if (!!e && e.indexOf('exists') == -1) {
                        this.PopUpService.openInformationModal((!!e ? e : 'Team Role could not be added.'));
                    } else
                        if (!!e) {
                            this.PopUpService.openInformationModal(e);
                        } else {
                            if (objCurrent.teamRoleId == -1)
                                objCurrent.teamRoleId = null;

                            deferred.reject();
                        }

                })
                return deferred.promise;
            }

            this.getExtension = (ext) => {

                const re = /(?:\.([^.]+))?$/;
                return re.exec(ext)[1];

            }

            this.setIsMobile = () => {
                this.isMobile = (window.innerWidth < 768);
            }

            this.showTooltipPopup = (tpl) => {
                if (!this.isMobile) {
                    return false;
                }
                PopUpService.openTooltipPopup(tpl, 'PopUpController as popUpVm', 'sp-info-tt')
            }

            this.getSignUrlFrSignature = (bucket, sgnUrl) => {
                const deferred = this.$q.defer();
                let env = (this.ecareEnv == "ecv-dev" ? "dev" : (this.ecareEnv == 'qa2' ? 'qa' : this.ecareEnv));
                let userId = this.CacheService.getUser().userId;
                const sassData = this.CacheService.getSASSToken();

                const url = `${this.storageConfig.url}/${bucket}/${sgnUrl}?${sassData.sasToken}`;
                deferred.resolve(url);

                return deferred.promise;
            }
        }
    }


angular.module('eCareVault.common.services')
    .service('CommonService', CommonService);
